export const FAQ_ITEMS = [
  {
    q: "Hur kommer vi igång med SalesPartner?",
    a: "En vuxen klass- eller gruppledare registrerar klassen eller laget och anger grupp samt planerad försäljningsperiod. Registreringen är en ansökan och behöver godkännas. Efter godkännande fortsätter onboarding.",
    to: "/register-group",
    linkLabel: "Registrera er grupp",
  },
  {
    q: "Vem registrerar gruppen?",
    a: "Det är en vuxen klass- eller gruppledare som registrerar gruppen.",
  },
  {
    q: "Hur säljer deltagarna?",
    a: "Varje säljare får en personlig säljlänk och QR-kod. Beställningar via länken kopplas till rätt säljare och grupp.",
    to: "/sa-fungerar-salespartner",
    linkLabel: "Så fungerar SalesPartner",
  },
  {
    q: "Behöver säljarna hantera kontanter?",
    a: "Nej. I det normala digitala flödet behöver säljarna inte hantera kontanter. Kunden ser de betalningsalternativ som är tillgängliga i kassan. Direktbetalning hanteras genom Stripe.",
  },
  {
    q: "Vad kan vi sälja?",
    a: "Gruppen säljer produkter ur SalesPartners aktuella sortiment.",
    to: "/products",
    linkLabel: "Se aktuellt sortiment",
  },
  {
    q: "Hur levereras beställningarna?",
    a: "Order kan levereras direkt till kunden eller som gruppleverans när det alternativet finns för beställningen.",
    to: "/leveransvillkor",
    linkLabel: "Läs leveransvillkoren",
  },
  {
    q: "Hur lång tid tar leveransen?",
    a: "Normal direktleverans är 3–5 arbetsdagar efter betalning och bekräftad order. Gruppleveransens timing kan variera.",
    to: "/leveransvillkor",
    linkLabel: "Läs leveransvillkoren",
  },
  {
    q: "Hur mycket tjänar gruppen?",
    a: "Provisionen är produkt- och variantbunden och kan variera. Faktisk förtjänst baseras på den faktiska provisionen på sålda produkter. Kalkylatorn på sidan om provision och förtjänst använder 74 kr i genomsnittlig provision per såld produkt som planeringsvärde. Det är inte en garanti eller fast provision.",
    to: "/provision-och-fortjanst",
    linkLabel: "Räkna på förtjänsten",
  },
  {
    q: "När betalas förtjänsten ut?",
    a: "Efter att alla order har levererats och 14 dagars väntetid har passerat kan förtjänsten betalas ut. Returer och återbetalningar kan påverka slutbeloppet.",
  },
  {
    q: "Fungerar SalesPartner för skolklasser?",
    a: "Ja. Skolklasser använder samma digitala försäljningsflöde. Mer om klassförsäljning finns på den egna sidan.",
    to: "/klassforsaljning",
    linkLabel: "Läs om klassförsäljning",
  },
  {
    q: "Fungerar SalesPartner för idrottslag?",
    a: "Ja. Idrottslag kan använda SalesPartner för att samla in pengar till laget.",
    to: "/tjana-pengar-till-laget",
    linkLabel: "Läs om försäljning till laget",
  },
  {
    q: "Fungerar SalesPartner för föreningar?",
    a: "Ja. Föreningar kan använda SalesPartner för sina grupper.",
    to: "/tjana-pengar-till-foreningen",
    linkLabel: "Läs om föreningsförsäljning",
  },
];

export function getFaqItemsByQuestion(questions) {
  return questions
    .map((question) => FAQ_ITEMS.find((item) => item.q === question))
    .filter(Boolean);
}
